/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PatientActivationLink model module.
 * @module model/PatientActivationLink
 * @version v0.3
 */
export default class PatientActivationLink {
  /**
   * Constructs a new <code>PatientActivationLink</code>.
   * @alias module:model/PatientActivationLink
   * @class
   * @param activationLink {String}
   */
  constructor(activationLink) {
    this.activationLink = activationLink;
  }

  /**
   * Constructs a <code>PatientActivationLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientActivationLink} obj Optional instance to populate.
   * @return {module:model/PatientActivationLink} The populated <code>PatientActivationLink</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientActivationLink();
      if (data.hasOwnProperty('activation_link'))
        obj.activationLink = ApiClient.convertToType(data['activation_link'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} activationLink
 */
PatientActivationLink.prototype.activationLink = undefined;
